import React from "react";
import Navbars from "../Components/navbar";
import Services from "./services";
import Footer from "../Components/Footer";





const Projectlink = () => {
    return(
        <>
          <Navbars />
          <div>
            <Services /> 
            <Footer />         
          </div>
        </>
    )
}

export default Projectlink;